export default __webpack_public_path__ + "static/media/indexpages.77611fd3.jpg";